import { render, staticRenderFns } from "./AvidiaTermsFeeSchedule.vue?vue&type=template&id=1327fc01&scoped=true"
import script from "./AvidiaTermsFeeSchedule.vue?vue&type=script&lang=ts"
export * from "./AvidiaTermsFeeSchedule.vue?vue&type=script&lang=ts"
import style0 from "./AvidiaTermsFeeSchedule.vue?vue&type=style&index=0&id=1327fc01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1327fc01",
  null
  
)

export default component.exports